import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Address = props => ___EmotionJSX(Fragment, null, props.appearance === 'single-line' && ___EmotionJSX("div", null, props.streetName, ", ", props.suburb, " ", props.state, " ", props.postcode), props.appearance === 'two-lines' && ___EmotionJSX("div", null, props.streetName, " ", props.suburb, " ", props.state, " ", props.postcode));
var propTypes = {
  appearance: PropTypes.oneOf(['single-line', 'two-lines']),
  postcode: PropTypes.string,
  state: PropTypes.string,
  streetName: PropTypes.string,
  suburb: PropTypes.string
};
var defaultProps = {
  appearance: 'single-line',
  postcode: null,
  state: null,
  streetName: null,
  suburb: null
};
Address.propTypes = propTypes;
Address.defaultProps = defaultProps;
export { propTypes, defaultProps };
export default Address;